// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// A site's posture — the three states the fleet map's legend and the site
// cards' status pill can show.
//
// The real fleet derives `healthy` / `at-risk` from live alarm counts: any
// open P1 makes a site "at risk" (see FleetOverview's resolvePosture). There
// is still no signal for `planned` — nothing reports that a site is still
// being built — so a real site never shows it; only a /fleet/demo scenario
// scripts `planned`, and says so on the page. If a real "still being built"
// signal lands, it produces this same type and every surface below follows
// without change.

export type SitePosture = 'healthy' | 'at-risk' | 'planned';

/** What the pill, the hover card and the legend call each state. */
export const POSTURE_LABEL: Record<SitePosture, string> = {
  healthy: 'Healthy',
  'at-risk': 'At risk',
  planned: 'Planned',
};

/**
 * Worst posture in a group, for a marker that stands for several sites.
 *
 * "Worst" is at-risk → healthy → planned, not the enum's order: a cluster
 * containing one failing data center must read as failing, and `planned`
 * ranks last because a site that is not live yet should never mask a live
 * one's state.
 */
export function worstPosture(postures: readonly SitePosture[]): SitePosture {
  if (postures.includes('at-risk')) return 'at-risk';
  if (postures.includes('healthy')) return 'healthy';
  return 'planned';
}
